import { render, staticRenderFns } from "./ClientTask.vue?vue&type=template&id=90117c5e&scoped=true&"
import script from "./ClientTask.vue?vue&type=script&lang=js&"
export * from "./ClientTask.vue?vue&type=script&lang=js&"
import style0 from "./ClientTask.vue?vue&type=style&index=0&id=90117c5e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90117c5e",
  null
  
)

export default component.exports